export default "__VITE_ASSET__a473f923__"